import * as ContextMenu from '@radix-ui/react-context-menu';
import { Pencil1Icon } from '@radix-ui/react-icons';
import { Flex, Theme } from '@radix-ui/themes';
import React from 'react';

interface NodeContextMenuProps {
  onDelete: () => void;
  children: React.ReactNode;
}

export function NodeContextMenu({ onDelete, children }: NodeContextMenuProps) {
  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger className="flex h-full w-full">
        {children}
      </ContextMenu.Trigger>
      <ContextMenu.Portal>
        <Theme>
          <ContextMenu.Content>
            <ContextMenu.Item>
              <Flex direction="row" justify="center" align="center" gap="2">
                <Pencil1Icon />
                Edit
              </Flex>
            </ContextMenu.Item>
            <ContextMenu.Item color="red" onClick={onDelete}>
              Delete
            </ContextMenu.Item>
          </ContextMenu.Content>
        </Theme>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
}
